App.ModifierGroupsIndexController = Em.Controller.extend
  needs: [ 'modifier-groups' ]

  env:     Em.inject.service('environment')
  session: Em.inject.service('session')
  modifierGroupsBinding: 'model'
  restaurantsBinding: 'controllers.modifier-groups.restaurants'
  canEditMenu: Em.computed.alias('session.accessRights.menuEdit')
  
  
  filteredModiferGroups: (->
    modifierGroups = @get('modifierGroups')
    return [] unless modifierGroups?.length
    modifierGroups.filter (group) => group.get('organization.id') is @get('session.currentOrganization.id')
  ).property('session.currentOrganization.id', 'modifierGroups.[]')

  actions:
    openModifierGroup: (modifierGroup) ->
      @transitionToRoute 'modifier-groups.edit', modifierGroup.get('id')
